import type { FC } from 'react';

import { L10nText } from '../../../../../services/uiTranslations/reactBindings/L10nText';
import type { PrivateMessageType } from '../../../../../store/slices/chat/types';
import { useModifiers } from '../../../../../styles/hooks/useModifiers';
import { Button, ButtonVariant } from '../../../../controls/button/Button';
import { Icon } from '../../../../icons/icon';
import { Icons } from '../../../../icons/iconNames';

import styles from './PrivateChatOptions.module.css';

export interface PrivateChatOptionsProps {
  expanded: boolean;
  privateChatOptions: PrivateMessageType[];
  handleSendMessage: (type: PrivateMessageType) => void;
  onToggle: () => void;
  isDisabled: boolean;
}

export const PrivateChatOptions: FC<PrivateChatOptionsProps> = ({
  expanded,
  privateChatOptions,
  handleSendMessage,
  onToggle,
  isDisabled,
}) => {
  const modsWrapper = useModifiers(
    styles,
    'privateChatOptionsWrapper',
    {
      expanded: expanded,
      disabled: isDisabled,
    },
    { withBaseClass: true }
  );

  return (
    <div className={modsWrapper}>
      {privateChatOptions ? (
        <div className={styles.privateMessageContainer}>
          {privateChatOptions.map((option: PrivateMessageType) => (
            <Button
              key={option.priveRequestType}
              className={styles.actionButton}
              variant={ButtonVariant.MAIN}
              onClick={() => handleSendMessage(option)}
            >
              <L10nText tk={option.name} />
            </Button>
          ))}
        </div>
      ) : null}
      <div className={styles.chevron_block}>
        <button className={styles.chevronButton} onClick={onToggle}>
          <Icon className={styles.chevronIcon} icon={Icons.ChevronDown} />
        </button>
      </div>
    </div>
  );
};
